export const categories = [
  {
    id: 1,
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    size: "large",
    tag: "TRENDING",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20single%20pair%20of%20white%20leather%20sneakers%20with%20natural%20wooden%20floor%20underneath%2C%20morning%20sunlight%20casting%20long%20soft%20shadows%2C%20minimalist%20composition%2C%20warm%20golden%20hour%20glow%2C%20textured%20oak%20floor%2C%20professional%20product%20photography%20with%20shallow%20depth%20of%20field%2C%20clean%20editorial%20style%2C%20no%20labels%20or%20text&width=600&height=600&seq=cat-new-01&orientation=squarish"
  },
  {
    id: 2,
    name: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    icon: "ri-t-shirt-line",
    size: "large",
    tag: "POPULAR",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20cozy%20oatmeal%20colored%20hoodie%20draped%20over%20a%20rustic%20wooden%20chair%20near%20a%20sunlit%20window%2C%20soft%20morning%20illumination%2C%20fabric%20texture%20visible%2C%20cream%20wall%20background%2C%20Scandinavian%20interior%20vibe%2C%20editorial%20lifestyle%20photography%2C%20warm%20neutral%20palette%2C%20high%20detail%20knit%20texture&width=600&height=600&seq=cat-new-02&orientation=squarish"
  },
  {
    id: 3,
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    icon: "ri-t-shirt-line",
    size: "small",
    tag: "",
    imageUrl: "https://readdy.ai/api/search-image?query=Neatly%20folded%20white%20cotton%20t-shirt%20on%20a%20marble%20countertop%20surface%2C%20natural%20light%20from%20large%20window%20reflecting%20softly%2C%20clean%20minimalist%20aesthetic%2C%20crisp%20fabric%20folds%2C%20professional%20ecommerce%20product%20photography%2C%20neutral%20gray%20marble%20texture%2C%20high%20contrast%20subtle%20shadows&width=400&height=400&seq=cat-new-03&orientation=squarish"
  },
  {
    id: 4,
    name: "Jackets",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    icon: "ri-shirt-line",
    size: "large",
    tag: "HOT",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20stylish%20olive%20green%20bomber%20jacket%20hanging%20on%20a%20minimalist%20wooden%20hanger%20against%20a%20textured%20concrete%20wall%2C%20dramatic%20side%20lighting%20from%20a%20single%20source%2C%20industrial%20loft%20aesthetic%2C%20high%20fashion%20editorial%20look%2C%20deep%20shadows%2C%20rich%20fabric%20texture%2C%20professional%20commercial%20photography&width=600&height=600&seq=cat-new-04&orientation=squarish"
  },
  {
    id: 5,
    name: "Pants/Shorts",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    icon: "ri-body-scan-line",
    size: "small",
    tag: "",
    imageUrl: "https://readdy.ai/api/search-image?query=Light%20beige%20linen%20trousers%20neatly%20laid%20flat%20on%20a%20rattan%20surface%2C%20tropical%20sunlight%20filtering%20through%20palm%20leaves%2C%20natural%20organic%20textures%2C%20warm%20earthy%20tones%2C%20vacation%20resort%20aesthetic%2C%20editorial%20fashion%20photography%2C%20soft%20breeze%20movement%2C%20clean%20composition&width=400&height=400&seq=cat-new-05&orientation=squarish"
  },
  {
    id: 6,
    name: "Headwear",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    icon: "ri-customer-service-2-line",
    size: "small",
    tag: "",
    imageUrl: "https://readdy.ai/api/search-image?query=Classic%20navy%20blue%20baseball%20cap%20resting%20on%20a%20stack%20of%20vintage%20books%20on%20a%20wooden%20desk%2C%20warm%20desk%20lamp%20glow%2C%20cozy%20study%20room%20atmosphere%2C%20dark%20academia%20vibe%2C%20rich%20textures%2C%20soft%20focused%20background%2C%20editorial%20still%20life%20photography&width=400&height=400&seq=cat-new-06&orientation=squarish"
  },
  {
    id: 7,
    name: "Sets",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    icon: "ri-stack-line",
    size: "small",
    tag: "NEW",
    imageUrl: "https://readdy.ai/api/search-image?query=Matching%20sage%20green%20loungewear%20set%20folded%20together%20on%20a%20plush%20cream%20bed%20with%20rumpled%20linen%20sheets%2C%20soft%20bedroom%20lighting%2C%20cozy%20relaxed%20aesthetic%2C%20textured%20cotton%20fabric%2C%20morning%20vibe%2C%20editorial%20home%20lifestyle%20photography%2C%20warm%20and%20inviting%20mood&width=400&height=400&seq=cat-new-07&orientation=squarish"
  },
  {
    id: 8,
    name: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    icon: "ri-user-line",
    size: "small",
    tag: "",
    imageUrl: "https://readdy.ai/api/search-image?query=Soft%20organic%20cotton%20underwear%20essentials%20arranged%20on%20a%20travertine%20stone%20surface%2C%20spa%20bathroom%20aesthetic%2C%20soft%20diffused%20natural%20light%2C%20eucalyptus%20sprig%20decoration%2C%20clean%20minimal%20wellness%20vibe%2C%20textured%20stone%20background%2C%20premium%20product%20photography%2C%20serene%20atmosphere&width=400&height=400&seq=cat-new-08&orientation=squarish"
  },
  {
    id: 9,
    name: "Jersey",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    icon: "ri-football-line",
    size: "small",
    tag: "",
    imageUrl: "https://readdy.ai/api/search-image?query=Basketball%20jersey%20in%20bold%20red%20and%20white%20draped%20over%20a%20gym%20bench%2C%20hardwood%20floor%20visible%2C%20dramatic%20arena%20spotlight%20effect%2C%20sports%20atmosphere%2C%20athletic%20energy%2C%20professional%20sports%20photography%20style%2C%20dynamic%20lighting%2C%20clean%20composition&width=400&height=400&seq=cat-new-09&orientation=squarish"
  },
  {
    id: 10,
    name: "Accessories",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    icon: "ri-vip-diamond-line",
    size: "large",
    tag: "ESSENTIAL",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20silver%20watch%20and%20leather%20bracelet%20on%20a%20dark%20slate%20stone%20surface%2C%20dramatic%20overhead%20lighting%2C%20luxury%20jewelry%20display%20aesthetic%2C%20reflective%20metallic%20surfaces%2C%20deep%20rich%20shadows%2C%20high%20end%20product%20photography%2C%20editorial%20fashion%20accessories%20shot%2C%20sophisticated%20mood&width=600&height=600&seq=cat-new-10&orientation=squarish"
  },
  {
    id: 11,
    name: "Bags",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    icon: "ri-briefcase-line",
    size: "small",
    tag: "",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20canvas%20tote%20bag%20leaning%20against%20a%20whitewashed%20brick%20wall%2C%20urban%20street%20style%20aesthetic%2C%20afternoon%20sunlight%20creating%20geometric%20shadows%2C%20city%20vibe%2C%20casual%20fashion%2C%20editorial%20street%20photography%20style%2C%20textured%20wall%20background%2C%20clean%20composition&width=400&height=400&seq=cat-new-11&orientation=squarish"
  },
  {
    id: 12,
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Bags.html",
    icon: "ri-link",
    size: "small",
    tag: "",
    imageUrl: "https://readdy.ai/api/search-image?query=Genuine%20leather%20belt%20elegantly%20coiled%20on%20a%20dark%20walnut%20wood%20surface%2C%20rich%20brown%20tones%2C%20warm%20candlelight%20ambiance%2C%20luxury%20leather%20goods%20aesthetic%2C%20brass%20buckle%20detail%2C%20gentleman%20style%2C%20editorial%20product%20photography%2C%20sophisticated%20dark%20background&width=400&height=400&seq=cat-new-12&orientation=squarish"
  },
  {
    id: 13,
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Bags.html",
    icon: "ri-drop-line",
    size: "small",
    tag: "",
    imageUrl: "https://readdy.ai/api/search-image?query=Crystal%20glass%20perfume%20bottle%20with%20golden%20liquid%20on%20a%20black%20marble%20surface%2C%20dramatic%20spotlight%20with%20sparkling%20reflections%2C%20luxury%20fragrance%20display%2C%20dark%20elegant%20background%2C%20premium%20beauty%20product%20photography%2C%20rich%20contrast%2C%20sophisticated%20moody%20lighting&width=400&height=400&seq=cat-new-13&orientation=squarish"
  },
  {
    id: 14,
    name: "OtherStuff",
    url: "https://kaspreadsheet.com/search-924/name/Bags.html",
    icon: "ri-more-line",
    size: "small",
    tag: "",
    imageUrl: "https://readdy.ai/api/search-image?query=Assorted%20fashion%20accessories%20including%20sunglasses%20and%20keychain%20scattered%20artfully%20on%20a%20terrazzo%20surface%2C%20colorful%20speckled%20stone%20background%2C%20bright%20natural%20daylight%2C%20playful%20editorial%20style%2C%20diverse%20textures%2C%20vibrant%20yet%20tasteful%20composition%2C%20commercial%20product%20photography&width=400&height=400&seq=cat-new-14&orientation=squarish"
  },
];

export const comparisonData = [
  { name: "OOPBuy Basic Sheet", bestFor: "Beginners", accuracy: 7, speed: 8, easeOfUse: 9, rating: 4.3, tag: "Beginner Pick" },
  { name: "Pro Research Sheet", bestFor: "Sellers", accuracy: 9, speed: 8, easeOfUse: 7, rating: 4.7, tag: "Top Rated" },
  { name: "Automation Sheet X", bestFor: "Scaling", accuracy: 10, speed: 9, easeOfUse: 6, rating: 4.8, tag: "Premium" },
  { name: "Enterprise Analytics", bestFor: "Teams", accuracy: 9, speed: 9, easeOfUse: 8, rating: 4.6, tag: "Team Pick" },
];